// src/components/GuestTimesPills.jsx — heures RÉELLES voyageur (formulaire de
// bienvenue) sous les yeux de l'ADMIN.
//
// Source de données : reservations.guest_arrival_time / guest_departure_time,
// propagées par lib/form-submit-handlers.js (propagateGuestTimes) à CHAQUE
// soumission du formulaire de bienvenue → la colonne porte toujours la
// DERNIÈRE soumission (UPDATE écrase). Colonnes TIME (migration
// 20260813000001_lot2_fiches_arrivee_guest_times_throttle.sql).
//
// ⚠️ Doctrine ADR-226 (heures réelles voyageur) :
//   - ADMIN = réel partout  → ce composant est réservé aux surfaces ADMIN.
//   - ORCHESTRATEUR = réel via endpoint dédié (GuestRealTimesLine, RunCard).
//   - AGENT MÉNAGE = créneau théorique cfg UNIQUEMENT — ne JAMAIS monter ce
//     composant sur une surface agent.
//   - PROPRIO : jamais (cf. proprio-rls-invariants) — sur un composant partagé
//     admin/proprio (ex. InboxThread readOnly), le caller DOIT gater le rendu.
//
// Rendu : puces sobres DS admin, UNIQUEMENT si au moins une heure est
// renseignée — jamais de « non renseigné ».

import { Clock } from "lucide-react"
import { DS } from "../lib/ui"

// "18:30:00" | "18:30" → "18h30" ; "09:00" → "9h00" ; invalide/absent → null.
export function formatGuestTimeFR(t) {
  if (t == null) return null
  const m = String(t).trim().match(/^(\d{1,2}):(\d{2})/)
  if (!m) return null
  const h = parseInt(m[1], 10)
  const min = parseInt(m[2], 10)
  if (h > 23 || min > 59) return null
  return `${h}h${m[2]}`
}

const PILL_STYLE = {
  display: "inline-flex",
  alignItems: "center",
  gap: 4,
  padding: "2px 9px",
  borderRadius: 999,
  background: DS.cielSoft,
  color: DS.marine,
  fontSize: 11,
  fontWeight: 600,
  whiteSpace: "nowrap",
}

export default function GuestTimesPills({ arrival, departure, style }) {
  const a = formatGuestTimeFR(arrival)
  const d = formatGuestTimeFR(departure)
  if (!a && !d) return null
  return (
    <div
      data-testid="guest-times-pills"
      style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap", ...style }}
    >
      {a && (
        <span data-testid="guest-times-pill-arrival" style={PILL_STYLE} title="Heure d'arrivée renseignée par le voyageur (formulaire de bienvenue, dernière soumission)">
          <Clock size={12} strokeWidth={2} /> Arrivée prévue {a}
        </span>
      )}
      {d && (
        <span data-testid="guest-times-pill-departure" style={PILL_STYLE} title="Heure de départ renseignée par le voyageur (formulaire de bienvenue, dernière soumission)">
          <Clock size={12} strokeWidth={2} /> Départ {d}
        </span>
      )}
    </div>
  )
}
